/* unplugin-vue-components disabled */import { render } from "./IncomePermissionBadge.vue?vue&type=template&id=68f80d16&scoped=true"
const script = {}

import "./IncomePermissionBadge.vue?vue&type=style&index=0&id=68f80d16&scoped=true&lang=css"
import "./IncomePermissionBadge.vue?vue&type=style&index=1&id=68f80d16&lang=css"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68f80d16"]])

export default __exports__